import { render, staticRenderFns } from "./ComponentSettings.vue?vue&type=template&id=07013490"
import script from "./ComponentSettings.vue?vue&type=script&lang=js"
export * from "./ComponentSettings.vue?vue&type=script&lang=js"
import style0 from "./ComponentSettings.vue?vue&type=style&index=0&id=07013490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports